import {IAPIAvatarData, IAvatarData} from './IAvatarData'

class Transformer {
    static transform (data: IAPIAvatarData): IAvatarData {
        return {
            id: data.id,
            isActive: data.is_active,
            url: data.url,
            uuid: data.uuid
        }
    }
}

export default Transformer